import type { ReactNode } from "react";
import { ProgressSpinnerSizes } from "../ProgressSpinnerSizes";

// The Lottie artwork has a wide transparent border, so it's drawn at twice the
// visible size and then pulled back by a quarter on each axis; the outer box
// clips what spills over. Literal classes per size — a computed
// `w-[${n}px]` generates nothing.
const outerClasses: Record<ProgressSpinnerSizes, string> = {
  [ProgressSpinnerSizes.Small]: "h-8 w-8 overflow-clip",
  [ProgressSpinnerSizes.Medium]: "h-16 w-16 overflow-clip",
  [ProgressSpinnerSizes.Large]: "h-32 w-32 overflow-clip",
};

const innerClasses: Record<ProgressSpinnerSizes, string> = {
  [ProgressSpinnerSizes.Small]: "relative -top-4 -left-4 h-16 w-16",
  [ProgressSpinnerSizes.Medium]: "relative -top-8 -left-8 h-32 w-32",
  [ProgressSpinnerSizes.Large]: "relative -top-16 -left-16 h-64 w-64",
};

interface IconsProgressSpinnerFrameProps {
  size: ProgressSpinnerSizes;
  children: ReactNode;
}

/**
 * Break glass: the clipping frame around the loading animation. Its whole job is
 * geometry — a fixed outer box, an inner box at twice the size, and a negative
 * offset that recentres the artwork inside the clip. Every value is a raw pixel
 * measurement of one piece of artwork, so there is no semantic prop to express
 * it and no ui-core primitive that owns an overflow clip.
 */
export function IconsProgressSpinnerFrame({
  size,
  children,
}: IconsProgressSpinnerFrameProps) {
  return (
    <div className={outerClasses[size]}>
      <div className={innerClasses[size]}>{children}</div>
    </div>
  );
}
